interface Props {
  color?: string
  width?: number
  height?: number
}

export const TriangleIcon = ({ color = '#6F6F6F', width = 21, height = 19 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.63622 1.48076L0.877258 16.4961C0.488375 17.1628 0.969247 18 1.74104 18H19.259C20.0308 18 20.5116 17.1628 20.1227 16.4961L11.3638 1.48076C10.9779 0.819259 10.0221 0.819256 9.63622 1.48076Z"
        stroke={color}
      />
    </svg>
  )
}
